import React from 'react';
import { motion } from 'framer-motion';
import ImageComparison from '../ui/ImageComparison';

const Comparison = () => {
  // Before: All red 20+ markers
  const beforeImage = "https://media-manager-c.questera.ai/greta-media/22508bb601940b4e20f7d160303c50efd71c7583e6bf992668d180d798243f38c2166642d2b71e0a7892275161f0f512/images/aW1hZ2Uvd2VicA==/1f9564a5db84d60fc5387f602776fce5.webp";
  
  // After: Improved ranking grid
  const afterImage = "https://media-manager-c.questera.ai/greta-media/22508bb601940b4e20f7d160303c50efd71c7583e6bf992668d180d798243f38c2166642d2b71e0a7892275161f0f512/images/aW1hZ2Uvd2VicA==/21f798a4311e4aab4f18928b76b93279.webp";

  return (
    <section className="py-28 relative bg-[#070b14] border-b border-white/5 overflow-hidden">
      {/* Background radial glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-5xl h-[500px] bg-blue-600/5 blur-[140px] rounded-full pointer-events-none"></div>
      
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="text-center mb-20 md:mb-24">
          <motion.h2 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1, duration: 0.8 }}
            className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-white mb-8 tracking-tighter"
          >
            Rank #1 on Google Maps & <span className="text-gradient">AI Mode faster with PRBoost</span>
          </motion.h2>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1.2, ease: [0.16, 1, 0.3, 1] }}
        >
          <ImageComparison beforeImage={beforeImage} afterImage={afterImage} />
        </motion.div>
      </div>
    </section>
  );
};

export default Comparison;